import { Button } from '@components'
import { SettingsDataCard } from '@pages/SettingsPage/components/SettingsDataCard'
import React from 'react'
import styled from 'styled-components'

interface Props {
  title: React.ReactNode
  description: string
  actionLabel: string
  actionIcon?: React.ReactElement
  icon?: React.ReactNode
}

export const DatevComingSoonCard: React.FC<Props> = ({
  title,
  description,
  actionLabel,
  actionIcon,
  icon
}) => (
  <Teaser>
    <SettingsDataCard
      icon={icon}
      title={title}
      body={
        <ComingSoonBody>
          <Description>{description}</Description>
          <Button type="button" size="sm" intent="primary" icon={actionIcon} disabled>
            {actionLabel}
          </Button>
        </ComingSoonBody>
      }
    />
  </Teaser>
)

const Teaser = styled.div`
  opacity: 0.65;
`

const ComingSoonBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing.sm}rem;
`

const Description = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.metalGray};
  font-size: ${({ theme }) => theme.fontSize.sm}rem;
  line-height: 1.45;
`
